import React, { useState } from "react";
import logo from "../image/Gplus Icon (1).webp";

import { useDispatch, useSelector } from "react-redux";
import {
  NavLink,
  Link,
  useNavigate,
} from "react-router-dom";

import { logout } from "../../actions/userActions";

import {
  FiLogOut,
  FiMenu,
  FiChevronDown,
  FiUser,
  FiGrid,
  FiPackage,
  FiArrowUpRight,
} from "react-icons/fi";

import { AiOutlineClose } from "react-icons/ai";
import { BiSolidDashboard } from "react-icons/bi";
import { MdBorderAll } from "react-icons/md";

import SideNavbar from "../SideNavbar/SideNavbar";

const Navbar = () => {
  const [hamberger, setHamberger] = useState(false);

  const { isAuthenticated, user } = useSelector(
    (state) => state.user
  );

  const {
    isAuthenticated: storeAuth,
    store,
  } = useSelector(
    (state) => state.storeAuth || {}
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* =========================================================
     AUTH
  ========================================================= */

  const isLoggedIn = isAuthenticated || storeAuth;
  const loginUser = user || store;

  /* =========================================================
     SERVICE
  ========================================================= */

  const handleServiceClick = () => {
    if (!isAuthenticated) {
      navigate("/login-with-otp");
    } else {
      navigate("/my-complaints");
    }
  };

  /* =========================================================
     LOGOUT
  ========================================================= */

  const logOut = () => {
    dispatch(logout());

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("storeAuth");

    window.location.href = "/login";
  };

  /* =========================================================
     DASHBOARD ROUTES
  ========================================================= */

  const dashboard = () => navigate("/dashboard");

  const dashboardSubadmin = () =>
    navigate("/dashboard-subAdmin");

  const orderDashboard = () =>
    navigate("/order-dashboard");

  const storeDashboard = () =>
    navigate("/admin/storepage");

  const account = () =>
    navigate("/profile");

  /* =========================================================
     USER OPTIONS
  ========================================================= */

  const options = [
    {
      icon: <FiUser />,
      name: "Profile",
      func: account,
    },
    {
      icon: <FiLogOut />,
      name: "Logout",
      func: logOut,
    },
  ];

  if (loginUser?.role === "admin") {
    options.unshift({
      icon: <BiSolidDashboard />,
      name: "Dashboard",
      func: dashboard,
    });
  }

  if (loginUser?.role === "subadmin") {
    options.unshift({
      icon: <BiSolidDashboard />,
      name: "Dashboard",
      func: dashboardSubadmin,
    });
  }

  if (loginUser?.role === "orderdashboard") {
    options.unshift({
      icon: <MdBorderAll />,
      name: "Order Dashboard",
      func: orderDashboard,
    });
  }

  if (storeAuth) {
    options.unshift({
      icon: <BiSolidDashboard />,
      name: "Store Dashboard",
      func: storeDashboard,
    });
  }

  /* =========================================================
     NAV ITEM STYLE
  ========================================================= */

  const navItemClass = ({ isActive }) =>
    `
      relative flex items-center gap-1.5
      px-2.5 py-2
      text-[13px]
      font-bold
      
      tracking-[-0.01em]
      transition-all duration-300
      ${
        isActive
          ? "text-[#ffffff]"
          : "text-[#ffffff] hover:text-[#ffffff]"
      }

      after:absolute
      after:left-2.5
      after:right-2.5
      after:bottom-0
      after:h-[2px]
      after:rounded-full
      after:bg-[#D6AD72]
      after:transition-all
      after:duration-300

      ${
        isActive
          ? "after:scale-x-100"
          : "after:scale-x-0 hover:after:scale-x-100"
      }
    `;

  return (
    <>
      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <header className="fixed inset-x-0 top-0 z-[100]">

        {/* TOP ACCENT LINE */}

        <div className="h-[2px] w-full bg-gradient-to-r from-[#ebb267] via-[#f95c1e] to-[#b00a1b]" />

        {/* MAIN NAVBAR */}

        <nav className="border-b border-white/[0.08] bg-gradient-to-r from-[#a9071a] via-[#9b111f] to-[#a9071a] shadow-[0_8px_30px_rgba(54,8,13,0.18)]">

          <div className="mx-auto flex h-[70px] max-w-[1600px] items-center justify-between px-4 sm:px-6 lg:h-[78px] lg:px-8 xl:px-10">

            {/* =================================================
                LOGO
            ================================================= */}

            <Link
              to="/"
              className="group flex shrink-0 items-center"
              aria-label="Gplus Home"
            >

              <img
                src={logo}
                alt="Gplus Home Appliances"
                className="
                  h-[42px]
                  w-auto
                  object-contain
                  transition-transform
                  duration-300
                  group-hover:scale-[1.03]

                  sm:h-[48px]
                  lg:h-[56px]
                "
              />

            </Link>

            {/* =================================================
                DESKTOP NAVIGATION
                lg and above
            ================================================= */}

            <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-center">

              <ul className="flex items-center gap-1 xl:gap-2">

                {/* HOME */}

                <li>
                  <NavLink
                    to="/"
                    className={navItemClass}
                  >
                    Home
                  </NavLink>
                </li>

                {/* ABOUT */}

                <li>
                  <NavLink
                    to="/about-us"
                    className={navItemClass}
                  >
                    About Us
                  </NavLink>
                </li>

                {/* =================================================
                    PRODUCTS DROPDOWN
                ================================================= */}

                <li className="group relative">

                  <button
                    type="button"
                    className="
                      relative
                      flex
                      items-center
                      gap-1.5
                      px-2.5
                      py-2
                      text-[13px]
                      font-bold
                      tracking-[-0.01em]
                      text-white
                      transition-all
                      duration-300
                      hover:text-[#F4D7A2]
                    "
                    aria-haspopup="true"
                  >
                    Products

                    <FiChevronDown
                      size={14}
                      className="
                        transition-transform
                        duration-300
                        group-hover:rotate-180
                      "
                    />

                  </button>

                  {/* DROPDOWN */}

                  <div
                    className="
                      invisible
                      absolute
                      left-1/2
                      top-full
                      z-[120]
                      w-[300px]
                      -translate-x-1/2
                      translate-y-2
                      pt-3
                      opacity-0
                      transition-all
                      duration-200

                      group-hover:visible
                      group-hover:translate-y-0
                      group-hover:opacity-100

                      group-focus-within:visible
                      group-focus-within:translate-y-0
                      group-focus-within:opacity-100
                    "
                  >

                    <div className="overflow-hidden rounded-[18px] border border-[#E8D4B5]/30 bg-[#FFFDF8] p-2 shadow-[0_25px_60px_rgba(45,7,12,0.22)]">

                      {/* DROPDOWN HEADER */}

                      <div className="border-b border-[#74141D]/10 px-4 py-3">

                        <p className="text-[9px] font-black uppercase tracking-[0.22em] text-[#f50c0c]">
                          Explore Collection
                        </p>

                        <p className="mt-1 text-xs text-[#1e1916]">
                          Discover Gplus home appliances
                        </p>

                      </div>

                      {/* LUXURY */}

                      <Link
                        to="/luxury-appliances"
                        className="
                          group/item
                          mt-2
                          flex
                          items-center
                          gap-3
                          rounded-[13px]
                          px-3
                          py-3
                          transition-all
                          duration-200
                          hover:bg-[#F6EBDD]
                        "
                      >

                        <span
                          className="
                            flex
                            h-10
                            w-10
                            shrink-0
                            items-center
                            justify-center
                            rounded-xl
                            bg-[#74141D]/10
                            text-[#74141D]
                            transition
                            group-hover/item:bg-[#74141D]
                            group-hover/item:text-white
                          "
                        >
                          <FiGrid size={17} />
                        </span>

                        <span className="flex-1">

                          <span className="block text-sm font-bold text-[#33231F]">
                            Luxury Appliances
                          </span>

                          <span className="mt-0.5 block text-[10px] text-[#4b2a18]">
                            Premium home appliances
                          </span>

                        </span>

                        <FiArrowUpRight
                          size={16}
                          className="text-[#e86c07] transition-transform duration-200 group-hover/item:translate-x-0.5 group-hover/item:-translate-y-0.5"
                        />

                      </Link>

                      {/* SMALL */}

                      <Link
                        to="/small-appliances"
                        className="
                          group/item
                          flex
                          items-center
                          gap-3
                          rounded-[13px]
                          px-3
                          py-3
                          transition-all
                          duration-200
                          hover:bg-[#F6EBDD]
                        "
                      >

                        <span
                          className="
                            flex
                            h-10
                            w-10
                            shrink-0
                            items-center
                            justify-center
                            rounded-xl
                            bg-[#74141D]/10
                            text-[#74141D]
                            transition
                            group-hover/item:bg-[#74141D]
                            group-hover/item:text-white
                          "
                        >
                          <FiPackage size={17} />
                        </span>

                        <span className="flex-1">

                          <span className="block text-sm font-bold text-[#33231F]">
                            Small Appliances
                          </span>

                          <span className="mt-0.5 block text-[10px] text-[#462818]">
                            Everyday kitchen essentials
                          </span>

                        </span>

                        <FiArrowUpRight
                          size={16}
                          className="text-[#f27603] transition-transform duration-200 group-hover/item:translate-x-0.5 group-hover/item:-translate-y-0.5"
                        />

                      </Link>

                    </div>

                  </div>

                </li>

                {/* CONTACT */}

                <li>
                  <NavLink
                    to="/contact-us"
                    className={navItemClass}
                  >
                    Contact Us
                  </NavLink>
                </li>

                {/* SERVICE */}

                <li>

                  <button
                    type="button"
                    onClick={handleServiceClick}
                    className="
                      relative
                      flex
                      items-center
                      gap-1.5
                      px-2.5
                      py-2
                      text-[13px]
                      font-bold
                      text-white
                      transition-all
                      duration-300
                      hover:text-[#F4D7A2]

                      after:absolute
                      after:left-2.5
                      after:right-2.5
                      after:bottom-0
                      after:h-[2px]
                      after:origin-center
                      after:scale-x-0
                      after:rounded-full
                      after:bg-[#D6AD72]
                      after:transition-transform
                      after:duration-300

                      hover:after:scale-x-100
                    "
                  >

                    Service

                  </button>

                </li>

                {/* BLOG */}

                <li>
                  <NavLink
                    to="/blogs"
                    className={navItemClass}
                  >
                    Blog
                  </NavLink>
                </li>

                {/* AWARDS */}

                <li>
                  <NavLink
                    to="/awards"
                    className={navItemClass}
                  >
                    Awards
                  </NavLink>
                </li>

              </ul>

            </div>

            {/* =================================================
                RIGHT SIDE / ACCOUNT
            ================================================= */}

            {/* =========================================================
    ACCOUNT / LOGIN
========================================================= */}

<div className="hidden lg:flex lg:shrink-0 lg:items-center">

  {isLoggedIn ? (

    /* =====================================================
       LOGGED-IN ACCOUNT
    ===================================================== */

    <div className="group relative">

      {/* ACCOUNT BUTTON */}

      <button
        type="button"
        aria-label="Open account menu"
        className="
          flex
          items-center
          gap-2.5
          rounded-full
          border
          border-white/15
          bg-white/[0.07]
          py-1.5
          pl-1.5
          pr-3
          text-left
          transition-all
          duration-300
          hover:border-[#D8B77E]/50
          hover:bg-white/[0.12]
          focus:outline-none
          focus:ring-2
          focus:ring-[#D8B77E]/30
        "
      >

        {/* AVATAR */}

        <span className="relative flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#D8B77E]/50 bg-[#F7EBDD]">

          <img
            src={
              loginUser?.avatar?.url ||
              "/user.png"
            }
            alt={
              loginUser?.name ||
              loginUser?.username ||
              "Account"
            }
            className="h-full w-full object-cover"
          />

        </span>

        {/* USER INFO */}

        <span className="hidden xl:block max-w-[105px]">

          <span className="block truncate text-[10px] font-medium uppercase tracking-[0.12em] text-[#D8B77E]">
            Account
          </span>

          <span className="mt-0.5 block truncate text-[12px] font-bold capitalize leading-tight text-[#FFF9F0]">
            {loginUser?.name ||
              loginUser?.username ||
              "Store"}
          </span>

        </span>

        {/* CHEVRON */}

        <FiChevronDown
          size={14}
          className="
            ml-0.5
            text-[#D8B77E]
            transition-transform
            duration-300
            group-hover:rotate-180
          "
        />

      </button>


      {/* ===================================================
          ACCOUNT DROPDOWN
      =================================================== */}

      <div
        className="
          invisible
          absolute
          right-0
          top-full
          z-[120]
          w-[270px]
          translate-y-3
          pt-3
          opacity-0
          transition-all
          duration-200

          group-hover:visible
          group-hover:translate-y-0
          group-hover:opacity-100

          group-focus-within:visible
          group-focus-within:translate-y-0
          group-focus-within:opacity-100
        "
      >

        <div
          className="
            overflow-hidden
            rounded-[20px]
            border
            border-[#E5D8C8]
            bg-[#FFFDF8]
            shadow-[0_24px_65px_rgba(52,8,14,0.22)]
          "
        >

          {/* =============================================
              PROFILE HEADER
          ============================================= */}

          <div className="bg-gradient-to-br from-[#5A0E16] via-[#68141D] to-[#4A0B12] px-4 py-4">

            <div className="flex items-center gap-3">

              <div className="relative shrink-0">

                <img
                  src={
                    loginUser?.avatar?.url ||
                    "/user.png"
                  }
                  alt=""
                  className="
                    h-11
                    w-11
                    rounded-full
                    border
                    border-[#E0BD80]/50
                    bg-white
                    object-cover
                  "
                />

                {/* ONLINE DOT */}

                <span className="
                  absolute
                  bottom-0
                  right-0
                  h-3
                  w-3
                  rounded-full
                  border-2
                  border-[#68141D]
                  bg-[#4CAF50]
                " />

              </div>

              <div className="min-w-0">

                <p className="
                  truncate
                  text-sm
                  font-bold
                  capitalize
                  text-white
                ">
                  {loginUser?.name ||
                    loginUser?.username ||
                    "Store"}
                </p>

                <p className="
                  mt-1
                  truncate
                  text-[9px]
                  font-semibold
                  uppercase
                  tracking-[0.18em]
                  text-[#D8B77E]
                ">
                  {loginUser?.role || "Account"}
                </p>

              </div>

            </div>

          </div>


          {/* =============================================
              ACCOUNT OPTIONS
          ============================================= */}

          <div className="p-2.5">

            {options.map((item, index) => (

              <button
                key={index}
                type="button"
                onClick={item.func}
                className="
                  group/account-item
                  flex
                  w-full
                  items-center
                  gap-3
                  rounded-[13px]
                  px-3
                  py-2.5
                  text-left
                  transition-all
                  duration-200
                  hover:bg-[#F7EBDD]
                "
              >

                {/* ICON */}

                <span
                  className="
                    flex
                    h-9
                    w-9
                    shrink-0
                    items-center
                    justify-center
                    rounded-xl
                    bg-[#741720]/[0.07]
                    text-[#741720]
                    transition-all
                    duration-200
                    group-hover/account-item:bg-[#741720]
                    group-hover/account-item:text-white
                  "
                >
                  {item.icon}
                </span>

                {/* LABEL */}

                <span className="
                  flex-1
                  text-[12px]
                  font-semibold
                  text-[#44352F]
                ">
                  {item.name}
                </span>

                {/* ARROW */}

                <FiArrowUpRight
                  size={14}
                  className="
                    text-[#B6A092]
                    opacity-0
                    transition-all
                    duration-200
                    group-hover/account-item:translate-x-0.5
                    group-hover/account-item:-translate-y-0.5
                    group-hover/account-item:opacity-100
                  "
                />

              </button>

            ))}

          </div>


          {/* =============================================
              SMALL FOOTER
          ============================================= */}

          <div className="
            border-t
            border-[#E9DED2]
            bg-[#FBF6EE]
            px-4
            py-2.5
          ">

            <p className="
              text-center
              text-[8px]
              font-bold
              uppercase
              tracking-[0.18em]
              text-[#9B8170]
            ">
              Gplus Home Appliances
            </p>

          </div>

        </div>

      </div>

    </div>

  ) : (

    /* =====================================================
       LOGIN BUTTON
    ===================================================== */

    <Link
      to="/login"
      className="
        group
        flex
        items-center
        gap-2.5
        rounded-full
        border
        border-[#D8B77E]/45
        bg-[#F7EBDD]
        px-4
        py-2
        text-[#68141D]
        shadow-[0_4px_18px_rgba(0,0,0,0.08)]
        transition-all
        duration-300
        hover:border-[#F3D9A5]
        hover:bg-white
        hover:shadow-[0_7px_22px_rgba(0,0,0,0.13)]
      "
    >

      {/* USER ICON */}

      <span
        className="
          flex
          h-7
          w-7
          items-center
          justify-center
          rounded-full
          bg-[#68141D]
          text-white
          transition-all
          duration-300
          group-hover:bg-[#4A0B12]
        "
      >
        <FiUser size={14} />
      </span>

      {/* TEXT */}

      <span className="
        text-[11px]
        font-black
        uppercase
        tracking-[0.12em]
      ">
        Login
      </span>

      {/* ARROW */}

      <FiArrowUpRight
        size={14}
        className="
          text-[#9A6F45]
          transition-transform
          duration-300
          group-hover:translate-x-0.5
          group-hover:-translate-y-0.5
        "
      />

    </Link>

  )}

</div>
            {/* =================================================
                MOBILE MENU BUTTON
            ================================================= */}

            <button
              type="button"
              aria-label={
                hamberger
                  ? "Close menu"
                  : "Open menu"
              }
              aria-expanded={hamberger}
              onClick={() =>
                setHamberger((prev) => !prev)
              }
              className="
                flex
                h-10
                w-10
                items-center
                justify-center
                rounded-xl
                border
                border-white/10
                bg-white/[0.06]
                text-[#FFF8ED]
                transition-all
                duration-300
                hover:border-[#D6AD72]/50
                hover:bg-[#FFF8ED]
                hover:text-[#68141D]

                lg:hidden
              "
            >

              {hamberger ? (
                <AiOutlineClose size={21} />
              ) : (
                <FiMenu size={21} />
              )}

            </button>

          </div>

        </nav>

      </header>

      {/* =====================================================
          MOBILE / TABLET SIDE NAVIGATION
      ===================================================== */}

      {hamberger && (
        <SideNavbar
          setHamberger={setHamberger}
        />
      )}
    </>
  );
};

export default Navbar;